import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaQuoteLeft } from "react-icons/fa";
import image1 from "../assets/images/21.png";
// import image2 from "../assets/images/3.jpg";
import image3 from "../assets/images/1.jpg";

const Testimonials = () => {
  const testimonials = [
    {
      image: image1,
      name: "FRIDAH K MUGAMBI",
      role: "H. TEACHER PRE-SCH",
      quote:
        "We provide a balanced daily schedule of physical activities, academics and quiet rest period that are developmentally appropriate for each child."
    },
    // {
    //   image: image2,
    //   name: "KEVIN A AGALOMBA",
    //   role: "H. TEACHER UPPER",
    //   quote:
    //     "Our endeavour is to enhance and grow talent at an early stage by using modern methods of teaching as we inculcate high moral values that will enrich the child to grow with high integrity, respect and demeanour."
    // },
    {
      image: image3,
      name: "VINCENT B FWOSI",
      role: "HEAD TEACHER",
      quote:
        "Enrolling your child with us will make it relatively easier and more flexible for you to attend to other important engagements in the day as we partner closely to bring up the child in knowledge and stature."
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000); // Change every 5 seconds
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="bg-gray-50 py-12 px-6 md:px-16"
    >
      <div className="text-center mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
          What People Say About Us
        </h2>
        <p className="text-gray-700 md:text-lg">
          Hear from students, parents, and alumni about their experiences at Joy Gardens School.
        </p>
      </div>

      <div className="w-full max-w-4xl mx-auto relative overflow-hidden group">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ type: "spring", stiffness: 100, damping: 20, duration: 0.5 }}
            className="p-6 bg-white rounded-lg shadow-lg"
          >
            <div className="text-center">
              <FaQuoteLeft className="text-yellow-500 text-4xl mx-auto mb-4" />
              <p className="text-gray-700 italic mb-4">
                "{testimonials[currentIndex].quote}"
              </p>
              <div className="flex justify-center mb-4">
                <img
                  src={testimonials[currentIndex].image}
                  alt={testimonials[currentIndex].name}
                  className="w-16 h-16 rounded-full border-2 border-blue-900"
                />
              </div>
              <h3 className="text-xl font-bold text-blue-900">
                {testimonials[currentIndex].name}
              </h3>
              <p className="text-sm text-gray-500">
                {testimonials[currentIndex].role}
              </p>
            </div>
          </motion.div>
        </AnimatePresence>

        <button
          onClick={prevSlide}
          className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-blue-500 text-white p-2 rounded-full hover:bg-blue-600 transition opacity-0 group-hover:opacity-100"
        >
          &#8592;
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-blue-500 text-white p-2 rounded-full hover:bg-blue-600 transition opacity-0 group-hover:opacity-100"
        >
          &#8594;
        </button>
      </div>
    </motion.section>
  );
};

export default Testimonials;
